import { graphql } from '@/gql';
import type { UpdateCoachingAssignmentMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type UpdateCoachingAssignmentInput = UpdateCoachingAssignmentMutationVariables['input'];

export const updateCoachingAssignment = async (id: string, input: UpdateCoachingAssignmentInput): Promise<void> => {
  await mutationExecute({
    mutation: graphql(`
      mutation UpdateCoachingAssignment($id: ID!, $input: UpdateCoachingAssignmentInput!) {
        updateCoachingAssignment(id: $id, input: $input) {
          id
        }
      }
    `),
    variables: { id, input },
  });
};
